import { useAtomValue } from 'jotai'
import { lastSaveWorkDateAtom, isSavingWorkAtom } from '../../store/saveWorkAtoms'
import { Check } from 'lucide-react'
import { useTar } from '@/modules/i18n'
import { useLocalSettings } from '@/hooks/useLocalSettings'
import { RelativeDateTime } from '@components/datetime'

export const LastWorkSave = () => {
  const { t } = useTar()
  const lastSaveDate = useAtomValue(lastSaveWorkDateAtom)
  const isSaving = useAtomValue(isSavingWorkAtom)
  const { getSetting } = useLocalSettings()

  if (getSetting('autosaveIndicator') === false) return null

  return (
    <div className="hidden lg:flex flex-col justify-center gap-1.5 ps-3 md:ps-4 md:pe-2">
      <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground leading-none">
        {t('common.autosave')}
      </span>
      <span className="flex items-center gap-1 text-sm font-medium text-primary leading-none">
        {isSaving ? (
          t('common.saving')
        ) : (
          <>
            <Check className="size-3.5" strokeWidth={3} />
            <RelativeDateTime isoDateString={lastSaveDate.toISOString()} calm />
          </>
        )}
      </span>
    </div>
  )
}
